import { PlainButton, Tooltip } from "@jugl-web/ui-components";
import { useTranslations, cx } from "@jugl-web/utils";
import { SIDEBAR_MAX_VISIBLE_ITEMS } from "@web-src/features/app/components/HomeSidebar/consts";
import { useMemo } from "react";
import { ReactComponent as PinIcon } from "./assets/pin.svg";
import { ReactComponent as UnpinIcon } from "./assets/unpin.svg";
import { ReactComponent as CheckIcon } from "./assets/check.svg";
import { ReactComponent as DisabledPinIcon } from "./assets/disabled-pin.svg";

export const PinButton = ({
  onClick,
  isPinned,
  hideTooltip = false,
  className,
  isHomePage,
  isAtLimit,
}: {
  onClick: (e: React.SyntheticEvent) => void;
  isPinned: boolean;
  hideTooltip?: boolean;
  isLabel?: boolean;
  className?: string;
  isHomePage?: boolean;
  isAtLimit?: boolean;
}) => {
  const { t } = useTranslations();

  const { content: tooltipContent, icon: buttonIcon } = useMemo(() => {
    if (isHomePage) {
      return {
        content: t({
          id: "personalize-menu-dialog.home-page.unpin",
          defaultMessage: "Home page can't be unpinned",
        }),
        icon: <CheckIcon />,
      };
    }
    if (isPinned) {
      return {
        content: t({
          id: "personalize-menu-dialog.unpin",
          defaultMessage: "Unpin from the side menu",
        }),
        icon: <UnpinIcon />,
      };
    }
    if (!isPinned && !isAtLimit) {
      return {
        content: t({
          id: "personalize-menu-dialog.pin",
          defaultMessage: "Pin to the side menu",
        }),
        icon: <PinIcon />,
      };
    }
    if (isAtLimit) {
      return {
        content: t(
          {
            id: "personalize-menu-dialog.pin-limit-reached",
            defaultMessage: "{limit}/{limit} Available spots is already taken",
          },
          {
            limit: SIDEBAR_MAX_VISIBLE_ITEMS,
          }
        ),
        icon: <DisabledPinIcon />,
      };
    }
    return {
      content: null,
      icon: null,
    };
  }, [isPinned, isHomePage, isAtLimit, t]);

  if (!tooltipContent && !buttonIcon) {
    return null;
  }

  return (
    <Tooltip
      isDisabled={hideTooltip}
      className="!z-[2001]"
      placement="right"
      renderTrigger={({ props, ref }) => (
        <PlainButton
          {...props}
          ref={ref}
          onClick={onClick}
          disabled={isHomePage || (!isPinned && isAtLimit)}
          className={cx(
            "text-primary-50 font-secondary hover:bg-dark-100 flex h-[28px] w-[28px] items-center justify-center gap-2 rounded-lg text-sm",
            className
          )}
        >
          {buttonIcon}
        </PlainButton>
      )}
    >
      {tooltipContent}
    </Tooltip>
  );
};
